import { ref, watch, computed, onMounted } from "@vue/composition-api";
import { formatCurrency } from "@core/utils/filter";
import axiosIns from "@/libs/axios";

// Notification
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import ability from "@/libs/acl/ability";

export default function useEditRecordsList(inComponent = false) {
  // Use toast
  const toast = useToast();

  const refEditRecordListTable = ref(null);

  // Table Handlers
  const tableColumns = [
    // { key: "id", label: "編號", sortable: true },
    { key: "project", label: "項目名稱" },
    { key: "project_id", stickyColumn: true, label: "項目編號", sortable: true },
    { key: "content", label: "主題", sortable: true },
    { key: "changed_data", label: "修改資料", sortable: true },
    // { key: "price", label: "價格", sortable: true, formatter: formatCurrency },
    { key: "user", label: "修改者" },
    // { key: "status", label: "狀態" },
    { key: "created_at", label: "創建日期" },
  ];
  const perPage = ref(10);
  const totalRow = ref(0);
  const currentPage = ref(1);
  const perPageOptions = [10, 25, 50, 100];
  const searchQuery = ref("");
  const sortBy = ref("id");
  const isSortDirDesc = ref(true);

  const editRecordsList = ref(null);

  const dataMeta = computed(() => {
    const localItemsCount = refEditRecordListTable.value
      ? refEditRecordListTable.value.localItems.length
      : 0;
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalRow.value,
    };
  });

  const refetchData = () => {
    refEditRecordListTable.value.refresh();
  };

  watch(
    [currentPage, perPage, searchQuery ],
    () => {
      refetchData();
    }
  );

  const fetchEditRecords = (ctx, callback) => {
    const params = {
      q: searchQuery.value,
      perPage: perPage.value,
      page: currentPage.value,
      sortBy: sortBy.value,
      sortDesc: isSortDirDesc.value,
      log_category_id: 1
    };
    axiosIns
      .get("user_logs/", { params })
      .then((response) => {
        const { user_logs, total } = response.data;
        callback(user_logs);
        totalRow.value = total;
        editRecordsList.value = user_logs
      })
      .catch((err) => {
        console.log(err);
        toast({
          component: ToastificationContent,
          props: {
            title: "獲取貸款清單時出錯",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      });
  };
 
  const userOptions = ref([]);

  const refetchOption = () => {
    store
      .dispatch("app/fetchOptionList", {
        user: true,
       
      })
      .then((response) => {
      
        userOptions.value = response.data.product_units;   
      });
  };


  onMounted(() => {
  });

  return {
    fetchEditRecords,
    tableColumns,
    perPage,
    currentPage,
    totalRow,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    editRecordsList,
    refEditRecordListTable,
    ability,
    refetchData,
   
  };
}
